<template>
  <div class="flex flex-col items-start text-left leading-snug">
    <span
      class="text-sm font-medium font-['Public Sans']"
      :class="info.tone === 'none' ? 'text-slate-400' : 'text-neutral-900'"
    >
      {{ info.date }}
    </span>
    <span
      v-if="info.hint"
      class="text-xs font-medium"
      :class="{
        'text-red-600': info.tone === 'overdue',
        'text-amber-600': info.tone === 'soon',
        'text-slate-500': info.tone === 'normal',
      }"
    >
      {{ info.hint }}
    </span>
  </div>
</template>

<script>
import { computed } from "vue";
import helpers from "@/helpers";

export default {
  props: {
    date: { type: [String, Date], default: null },
    status: { type: String, default: "" },
  },
  setup(props) {
    const info = computed(() => helpers.dueDateInfo(props.date, props.status));
    return { info };
  },
};
</script>
